export const dictionaryErrors = { AREADESX: "Nombre del Area", AREAPATH: "Nombre del Path" };
